import { collection, query, where, getDocs, deleteDoc, doc, setDoc, getDoc, collectionGroup } from "firebase/firestore";
import { db } from "../firebase.config";

export const getQuotationsList = async (tenantId) => {
    // its should return json array of Quotation array to database

    let returnStringValn = []
    
    const querySnapshot = await getDocs(collection(db, "quotations"));
    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, " => ", doc.data());
        returnStringValn.push(doc.data());
    });


    const qArray = [];
    // const querySnapshot = await getDocs(
    //     collection(firestore, "PinCode_Master"),
    //     where("isDeliveryLocationActive", "==", "Y")
    //   );
    querySnapshot.forEach((doc) => {
        const qRecord = {
            // qId: doc.data().qId,
            // shipTo: doc.data().shipTo,
            // quotationTo: doc.data().quotationTo,
            // date: doc.data().date,
            // validity: doc.data().validity,
            // totalAmount: doc.data().totalAmount,

            qId: doc.data().qId,
            shipTo: doc.data().shipTo,
            quotationTo: doc.data().quotationTo,
            date: doc.data().date,
            validityDate: doc.data().validityDate,
            items: doc.data().items,
            additionalNotes: doc.data().additionalNotes,
            cgstAmount: doc.data().cgstAmount,
            sgstAmount: doc.data().sgstAmount,
            taxableAmount: doc.data().taxableAmount,
            totalAmount: doc.data().totalAmount,
            totalGstAmount: doc.data().totalGstAmount, 
            termsAndConditions:doc.data().termsAndConditions,
            customBanner:doc.data().customBanner,
            customFooter:doc.data().customFooter

        };
        qArray.push(JSON.stringify(qRecord));
    });

    console.log("Pincode array is >> ", qArray)

    return qArray;



    // console.log ("printing json object",JSON.parse(returnStringValn));

    // console.log ("printing json object",returnStringValn);

    // // return JSON.parse(returnStringValn);
    // return querySnapshot.docs.map(doc => doc.data());


}
export const getQuotationsListstub = (tenantId) => {
    // its should return json array of Quotation array to database

    let returnStringValn = [
        {
            "id": "Q110220250002",
            "quotationTo": "aryan",
            "date": "2025-02-09",
            "validity": "2025-02-13",
            "amount": "118"
        },
        {
            "id": "Q110220250003",
            "quotationTo": "kunal",
            "date": "2025-02-10",
            "validity": "2025-02-14",
            "amount": "158"
        },
        {
            "id": "Q110220250004",
            "quotationTo": "vishu",
            "date": "2025-02-08",
            "validity": "2025-02-12",
            "amount": "128"
        }

    ]
    // console.log ("printing json object",JSON.parse(returnStringValn));

    console.log("printing json object", returnStringValn);

    // return JSON.parse(returnStringValn);
    return returnStringValn;
}

//#####################################################

export const getLevel1ProductList = async (tenantid) => {
    //     //Get level 1  data of Derived and Standard Products - Services from Catalogue collection for given Tenant
    //     //Return JSON array of Catalogue items 

    try {
        const q = query(
            collection(db, "Catalogue"),
            where("TenantID", "==", tenantid),
            where("IsActive", "==", true)
            //where("Type", "==" ,10,20,"*")
        );

        const querySnapshot = await getDocs(q);
        const products = [];

        querySnapshot.forEach((doc) => {
            products.push({ id: doc.id, ...doc.data() });
          });

          console.log("Level 1 Products pushed:", products);

        // querySnapshot.forEach((doc) => {

        //     console.log( " Level 1 querysnapshot document is >>> ", doc);

        //     products.push({
        //         id: doc.id,
        //         // productId: doc.data().productId,
        //         name: doc.data().name,
        //         description: doc.data().description,
        //         type: doc.data().type, // 'Standard' or 'Derived'
        //         price: doc.data().price,
        //         status: doc.data().status || 'active',
        //         tenantId: doc.data().tenantId,
        //         level: 1,
        //         createdAt: doc.data().createdAt,
        //         updatedAt: doc.data().updatedAt
        //     });
        // });

        return products;
    } catch (error) {
        console.error("Error fetching level 1 products:", error);
        throw error;
    }
}

export const getLevel1ProductListStub = async (tenantid) => {

}


//###################################################################


// export function getLevel2ProductList ( tenantId = 1, level1ProdId) {
//     //Get level 2 data of Derived and Standard Products - Services from Catalogue collection for given Tenant and level1Id
//     //Return JSON array of Catalogue items 
//     //
// }



export const getLevel2ProdListstub = (tenantId) => {
    // its should return json array of Quotation array to database

    let returnStringValn = [

        {
            "ProdID": "P23321132",
            "ProdName": "Drilling Machine",
            "Details": "sampleDetails",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "D12",
            "ChildIDs": "",
            "Type": 10,
            "Level": 0,
            "LastUpdatedOn": "15/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true,
        },

        {
            "ProductID": "P797689",
            "ProdName": "Braking unit",
            "Details": "sampleDetails of derived Product",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "",
            "ChildIDs": "",
            "Type": 20,
            "Level": 0,
            "LastUpdatedOn": "13/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true,
        },

        {
            "ProductID": "PS880990",
            "ProdName": "Hammer",
            "Details": "sampleDetails of Standard Product",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "",
            "ChildIDs": "",
            "Type": 10,
            "Level": 0,
            "LastUpdatedOn": "15/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": false,
        }


    ]
    // console.log ("printing json object",JSON.parse(returnStringValn));

    console.log("printing json object", returnStringValn);

    // return JSON.parse(returnStringValn);
    return returnStringValn;
}


export const getLevel2ProductList = async (tenantId, prodIDL1) => {
    //     //Get level 2  data of Derived and Standard Products - Services from Catalogue collection for given Tenant
    //     //Return JSON array of Catalogue items 

    try {

            // console.log("Inside getLevel2ProdList >>", tenantId, prodIDL1);

            const q = query(
                collection(db, "Catalogue"),
                where("TenantID", "==", tenantId),
                where("ParentIDs", "==", prodIDL1),
                where("IsActive", "==", true)
            );
    
            const querySnapshot = await getDocs(q);
            const products = [];
            
            // console.log("Level 2 querySnapshot outcome",querySnapshot);
            
            querySnapshot.forEach((doc) => {
                products.push({ id: doc.id, ...doc.data() });
              });

        console.log("Level 2 Products pushed:", products);

        return products;
    } catch (error) {
        console.error("Error fetching level 1 products:", error);
        throw error;
    }
}

//############################################################

export const getLevel3ProductList = async (tenantId, prodIDL2) => {
    //     //Get level 3 data of Derived and Standard Products - Services from Catalogue collection for given Tenant and level2Id
    //     //Return JSON array of Catalogue items 

    try {
        const q = query(
            collection(db, "Catalogue"),
            where("TenantID", "==", tenantId),
            where("ParentIDs", "==", prodIDL2),
            where("Type", "==", 10),                // level 3 will always have Standard Products
            where("IsActive", "==", true)
        );

        const querySnapshot = await getDocs(q);
        const products = [];

        // console.log("Level 3 querySnapshot outcome",querySnapshot);

        querySnapshot.forEach((doc) => {
            products.push({ id: doc.id, ...doc.data() });
          });

          console.log("Level 3 Products pushed:", products);

        return products;
    } catch (error) {
        console.error("Error fetching level 3 products:", error);
        throw error;
    }

}


// export function getLevel3ProductListStub ( tenantId = 1) {
//}

//##############################################################

// export function setLevel1Product ( tenantId = 1,catlogueLevel1ItemJson) {
//     //Get level 1  data of Derived and Standard Products - Services from Catalogue collection for given Tenant
//     //Return JSON array of Catalogue items 

// }

export const setLevel1ProdListstub = async (tenantId, catlogueLevel1ItemJson) => {
    // its should return json array of Quotation array to database

    let addProdDataVal = [
        {
            "ProductID": "P23321132",
            "ProdName": "Drilling bit",
            "Details": "sampleDetails",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "",
            "ChildIDs": "",
            "Type": 20,
            "Level": 0,
            "LastUpdatedOn": "15/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true
        },

        {
            "ProductID": "P797689",
            "ProdName": "Display system",
            "Details": "sampleDetails of derived Product",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "",
            "ChildIDs": "",
            "Type": 20,
            "Level": 0,
            "LastUpdatedOn": "13/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true
        },

        {
            "ProductID": "PS880990",
            "ProdName": "4mm bore",
            "Details": "sampleDetails of Standard Product",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "",
            "ChildIDs": "",
            "Type": 10,
            "Level": 0,
            "LastUpdatedOn": "15/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": false
        }
    ]
    // console.log ("printing json object",JSON.parse(returnStringValn));
    addProdDataVal.map(async (r) => {
        console.log("values of r:", r.ProductID);
        await setDoc(doc(db, "Catalogue", r.ProductID), {
            ProductID: r.ProductID,
            ProdName: r.ProdName,
            Details: r.Details,
            HSNCode: r.HSNCode,
            GST: r.GST,
            MOQ: r.MOQ,
            UnitPrice: r.UnitPrice,
            UnitDiscount: r.UnitDiscount,
            UnitCGSTRate: r.UnitCGSTRate,
            UnitSGSTRate: r.UnitSGSTRate,
            UnitIGSTRate: r.UnitIGSTRate,
            ParentIDs: r.ParentIDs,
            ChildIDs: r.ChildIDs,
            Type: r.Type,
            Level: r.Level,
            LastUpdatedOn: r.LastUpdatedOn,
            LastUpdatedBy: r.LastUpdatedBy,
            TenantID: r.TenantID,
            IsActive: r.IsActive
        });
    })

    console.log("printing json object", addProdDataVal.length);

    // return JSON.parse(returnStringValn);
    return true;
}


//##############################################################

// export function setLevel2Product ( tenantId = 1, catlogueLevel1ItemId , catlogueLevel2ItemJson) {
//     // We have to add catlogueLevel2ItemJson in catlogueCollection if this already exist it should not be added
//     // if this record exist in db,then it should be updated for thr given tenantId
//     // Update the childIds field of catlogueLevel1ItemId with catlogueLevel2ItemJson
//     // if add or update of record to database succeeds then return true or false 
// }

export function setLevel2ProductStub(tenantId = 1, catlogueLevel1ItemId, catlogueLevel2ItemJson) {
    // its should return json array of Quotation array to database

    let addProdDataVal = [

        {
            "ProductID": "P22222",
            "ProdName": "Needle separator",
            "Details": "Level 2 product",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "P797689",
            "ChildIDs": "",
            "Type": 20,
            "Level": 0,
            "LastUpdatedOn": "23/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true,
        },

        {
            "ProductID": "P9090",
            "ProdName": "Hammer Drill",
            "Details": "sampleDetails of derived Product",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "",
            "ChildIDs": "",
            "Type": 20,
            "Level": 0,
            "LastUpdatedOn": "13/12/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true,
        },

        {
            "ProductID": "PS88888",
            "ProdName": "Spanner",
            "Details": "Sample level 2 data",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "P797689",
            "ChildIDs": "",
            "Type": 10,
            "Level": 0,
            "LastUpdatedOn": "15/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": false,
        }


    ]
    // console.log ("printing json object",JSON.parse(returnStringValn));
    addProdDataVal.map(async (r) => {

        console.log("values of r setLevel 2 docs:", r.ProductID);


        await setDoc(doc(db, "Catalogue", r.ProductID), {
            ProductID: r.ProductID,
            ProdName: r.ProdName,
            Details: r.Details,
            HSNCode: r.HSNCode,
            GST: r.GST,
            MOQ: r.MOQ,
            UnitPrice: r.UnitPrice,
            UnitDiscount: r.UnitDiscount,
            UnitCGSTRate: r.UnitCGSTRate,
            UnitSGSTRate: r.UnitSGSTRate,
            UnitIGSTRate: r.UnitIGSTRate,
            ParentIDs: r.ParentIDs,
            ChildIDs: r.ChildIDs,
            Type: r.Type,
            Level: r.Level,
            LastUpdatedOn: r.LastUpdatedOn,
            LastUpdatedBy: r.LastUpdatedBy,
            TenantID: r.TenantID,
            IsActive: r.IsActive

            // name: "XYZ"
        });
    }



    )

    // console.log("printing json object", addProdDataVal.length);

    // return JSON.parse(returnStringValn);
    return true;
}


//##############################################################

// export function setLevel3Product ( tenantId = 1) {
//     // We have to add catlogueLevel2ItemJson in catlogueCollection if this already exist it should not be added
//     // if this record exist in db,then it should be updated for thr given tenantId
//     // Update the childIds field of catlogueLevel1ItemId with catlogueLevel2ItemJson
//     // if add or update of record to database succeeds then return true or false  

// }

export function setLevel3ProductStub(tenantId = 1, catlogueLevel1ItemId, catlogueLevel2ItemJson) {
    // its should return json array of Quotation array to database

    let addProdDataVal = [

        {
            "ProductID": "PS44444",
            "ProdName": "Sowing Tool",
            "Details": "Level 3 product",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "P22222",
            "ChildIDs": "",
            "Type": 10,
            "Level": 0,
            "LastUpdatedOn": "23/06/25",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true,
        },

        {
            "ProductID": "PS5555",
            "ProdName": "Iron Cutting Rod",
            "Details": "Level 3 products",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "P22222",
            "ChildIDs": "",
            "Type": 10,
            "Level": 0,
            "LastUpdatedOn": "02/02/24",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true,
        },

        {
            "ProductID": "PS66666",
            "ProdName": "Chisel",
            "Details": "Sample level 3 data",
            "HSNCode": "ABC",
            "GST": "27XXXXXXXXXXX09",
            "MOQ": 5,
            "UnitPrice": 12.2,
            "UnitDiscount": 0.01,
            "UnitCGSTRate": 0.06,
            "UnitSGSTRate": 0.06,
            "UnitIGSTRate": 0.0,
            "ParentIDs": "",
            "ChildIDs": "",
            "Type": 10,
            "Level": 0,
            "LastUpdatedOn": "25/04/23",
            "LastUpdatedBy": "abc@gmail.com",
            "TenantID": "10",
            "IsActive": true,
        }


    ]
    // console.log ("printing json object",JSON.parse(returnStringValn));
    addProdDataVal.map(async (r) => {

        console.log("values of r setLevel 333 docs:", r.ProductID);


        await setDoc(doc(db, "Catalogue", r.ProductID), {
            ProductID: r.ProductID,
            ProdName: r.ProdName,
            Details: r.Details,
            HSNCode: r.HSNCode,
            GST: r.GST,
            MOQ: r.MOQ,
            UnitPrice: r.UnitPrice,
            UnitDiscount: r.UnitDiscount,
            UnitCGSTRate: r.UnitCGSTRate,
            UnitSGSTRate: r.UnitSGSTRate,
            UnitIGSTRate: r.UnitIGSTRate,
            ParentIDs: r.ParentIDs,
            ChildIDs: r.ChildIDs,
            Type: r.Type,
            Level: r.Level,
            LastUpdatedOn: r.LastUpdatedOn,
            LastUpdatedBy: r.LastUpdatedBy,
            
            TenantID: r.TenantID,
            IsActive: r.IsActive

            // name: "XYZ"
        });
    }



    )

    // console.log("printing json object", addProdDataVal.length);

    // return JSON.parse(returnStringValn);
    return true;
}

//###############################################################

export const deleteQuot = async (tenantId = 1, quotId) => {
    // First we have to check whether Qid is null or not ''
    //If quotId is valid we have to made delete method
    // We will boolean if it correct then true else false 

    try {
        console.log("Id", quotId);
        const delref = await deleteDoc(doc(db, "quotations", quotId));
        console.log("Delete Perform");
        return true;
    }
    catch (e) {
        console.log("while deleting the quotation", e.message);
        return false;
    }
}


// export const  deleteQuotStub = async ( tenantId = 1,quotId)  =>  {
// }

//###########################################################

//###############################################################
// get the quotation record for view based on the Quotation id shared
// tenant id is current missing in this transaction which should be added

export const getQuoteForView = async (tenantID, quoteID)=>{

    console.log("Quotation id received for retrieval", quoteID);

    const docRef = doc(db, "quotations", quoteID);
    const quoteDtlsSnap = await getDoc(docRef);

    //const quoteDtlsSnap = await getDoc(db, "quotations", quoteID);
    let returnQuoteDtls = [];

    if (quoteDtlsSnap.exists()) {
        console.log("Document data:", quoteDtlsSnap.data());
        
        console.log("quotation snapshot length is", quoteDtlsSnap.length);
        // quoteDtlsSnap.forEach((doc) => {
            const doc = quoteDtlsSnap;
            // doc.data() is never undefined for query doc snapshots
            console.log(doc.id, " => ", doc.data());

            const qRecDtls = {
                qId: doc.data().qId,
                shipTo: doc.data().shipTo,
                quotationTo: doc.data().quotationTo,
                date: doc.data().date,
                validityDate: doc.data().validityDate,
                items: doc.data().items,
                additionalNotes: doc.data().additionalNotes,
                cgstAmount: doc.data().cgstAmount,
                sgstAmount: doc.data().sgstAmount,
                taxableAmount: doc.data().taxableAmount,
                totalAmount: doc.data().totalAmount,
                totalGstAmount: doc.data().totalGstAmount, 
                termsAndConditions:doc.data().termsAndConditions,
                customBanner:doc.data().customBanner,
                customFooter:doc.data().customFooter

                        
            }
            returnQuoteDtls.push(JSON.stringify(qRecDtls));
            
        // });

      } else {
        // docSnap.data() will be undefined in this case
        console.log("No such document!");
      }
      return returnQuoteDtls;
}

//###############################################################
// Template Management Functions - Migration to tenant subcollection
//###############################################################

/**
 * Save invoice template configuration to tenant's invoiceTemplates subcollection
 * @param {string} tenantId - Tenant ID
 * @param {string} templateName - Template name (e.g., 'InTemplate', 'InTemplate2')
 * @param {object} templateData - Template configuration data
 */
export const saveInvoiceTemplate = async (tenantId, templateName, templateData) => {
  try {
    const templateRef = doc(db, `tenants/${tenantId}/invoiceTemplates`, templateName);
    await setDoc(templateRef, {
      ...templateData,
      updatedAt: new Date().toISOString(),
    }, { merge: true });
    console.log(`Invoice template '${templateName}' saved for tenant ${tenantId}`);
    return true;
  } catch (error) {
    console.error("Error saving invoice template:", error);
    throw error;
  }
};

/**
 * Save quotation template configuration to tenant's quotationTemplates subcollection
 * @param {string} tenantId - Tenant ID
 * @param {string} templateName - Template name (e.g., 'QTemplate', 'QTemplate6')
 * @param {object} templateData - Template configuration data
 */
export const saveQuotationTemplate = async (tenantId, templateName, templateData) => {
  try {
    const templateRef = doc(db, `tenants/${tenantId}/quotationTemplates`, templateName);
    await setDoc(templateRef, {
      ...templateData,
      updatedAt: new Date().toISOString(),
    }, { merge: true });
    console.log(`Quotation template '${templateName}' saved for tenant ${tenantId}`);
    return true;
  } catch (error) {
    console.error("Error saving quotation template:", error);
    throw error;
  }
};

/**
 * Get all invoice templates for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const getInvoiceTemplates = async (tenantId) => {
  try {
    const templatesRef = collection(db, `tenants/${tenantId}/invoiceTemplates`);
    const querySnapshot = await getDocs(templatesRef);
    const templates = [];
    querySnapshot.forEach((doc) => {
      templates.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    console.log(`Retrieved ${templates.length} invoice templates for tenant ${tenantId}`);
    return templates;
  } catch (error) {
    console.error("Error retrieving invoice templates:", error);
    return [];
  }
};

/**
 * Get all quotation templates for a tenant
 * @param {string} tenantId - Tenant ID
 */
export const getQuotationTemplates = async (tenantId) => {
  try {
    const templatesRef = collection(db, `tenants/${tenantId}/quotationTemplates`);
    const querySnapshot = await getDocs(templatesRef);
    const templates = [];
    querySnapshot.forEach((doc) => {
      templates.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    console.log(`Retrieved ${templates.length} quotation templates for tenant ${tenantId}`);
    return templates;
  } catch (error) {
    console.error("Error retrieving quotation templates:", error);
    return [];
  }
};

/**
 * Get a specific invoice template for a tenant
 * @param {string} tenantId - Tenant ID
 * @param {string} templateName - Template name
 */
export const getInvoiceTemplate = async (tenantId, templateName) => {
  try {
    const templateRef = doc(db, `tenants/${tenantId}/invoiceTemplates`, templateName);
    const templateSnap = await getDoc(templateRef);
    if (templateSnap.exists()) {
      return {
        id: templateSnap.id,
        ...templateSnap.data(),
      };
    }
    console.log(`Invoice template '${templateName}' not found for tenant ${tenantId}`);
    return null;
  } catch (error) {
    console.error("Error retrieving invoice template:", error);
    return null;
  }
};

/**
 * Get a specific quotation template for a tenant
 * @param {string} tenantId - Tenant ID
 * @param {string} templateName - Template name
 */
export const getQuotationTemplate = async (tenantId, templateName) => {
  try {
    const templateRef = doc(db, `tenants/${tenantId}/quotationTemplates`, templateName);
    const templateSnap = await getDoc(templateRef);
    if (templateSnap.exists()) {
      return {
        id: templateSnap.id,
        ...templateSnap.data(),
      };
    }
    console.log(`Quotation template '${templateName}' not found for tenant ${tenantId}`);
    return null;
  } catch (error) {
    console.error("Error retrieving quotation template:", error);
    return null;
  }
};

/**
 * Delete an invoice template from a tenant
 * @param {string} tenantId - Tenant ID
 * @param {string} templateName - Template name
 */
export const deleteInvoiceTemplate = async (tenantId, templateName) => {
  try {
    const templateRef = doc(db, `tenants/${tenantId}/invoiceTemplates`, templateName);
    await deleteDoc(templateRef);
    console.log(`Invoice template '${templateName}' deleted for tenant ${tenantId}`);
    return true;
  } catch (error) {
    console.error("Error deleting invoice template:", error);
    throw error;
  }
};

/**
 * Delete a quotation template from a tenant
 * @param {string} tenantId - Tenant ID
 * @param {string} templateName - Template name
 */
export const deleteQuotationTemplate = async (tenantId, templateName) => {
  try {
    const templateRef = doc(db, `tenants/${tenantId}/quotationTemplates`, templateName);
    await deleteDoc(templateRef);
    console.log(`Quotation template '${templateName}' deleted for tenant ${tenantId}`);
    return true;
  } catch (error) {
    console.error("Error deleting quotation template:", error);
    throw error;
  }
};



